import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { addDays } from "date-fns";

function PopularDestinations() {
  const navigate = useNavigate();

  const destinations = [
    {
      city: "Bangkok",
      flag: "🇹🇭",
      coordinates: {
        latitude: 13.7563,
        longitude: 100.5018,
      },
      image: "bangkok.webp",
    },
    {
      city: "Istanbul",
      flag: "🇹🇷",
      coordinates: {
        latitude: 41.0082,
        longitude: 28.9784,
      },
      image: "istanbul.webp",
    },
    {
      city: "London",
      flag: "🇬🇧",
      coordinates: {
        latitude: 51.5074,
        longitude: -0.1278,
      },
      image: "london.webp",
    },
    {
      city: "New York",
      flag: "🇺🇸",
      coordinates: {
        latitude: 40.7128,
        longitude: -74.006,
      },
      image: "new-york.webp",
    },
    {
      city: "Antalya",
      flag: "🇹🇷",
      coordinates: {
        latitude: 36.8969,
        longitude: 30.7133,
      },
      image: "antalya.webp",
    },
    {
      city: "Dubai",
      flag: "🇦🇪",
      coordinates: {
        latitude: 25.2048,
        longitude: 55.2708,
      },
      image: "dubai.webp",
    },
    {
      city: "Paris",
      flag: "🇫🇷",
      coordinates: {
        latitude: 48.8566,
        longitude: 2.3522,
      },
      image: "paris.webp",
    },
    {
      city: "Barbados",
      flag: "🇧🇧",
      coordinates: {
        latitude: 13.1939,
        longitude: -59.5432,
      },
      image: "barbados.webp",
    },
    {
      city: "Buenos Aires",
      flag: "🇦🇷",
      coordinates: {
        latitude: -34.6037,
        longitude: -58.3816,
      },
      image: "buenos-aires.webp",
    },
  ];

  const handleClick = (destination) => {
    const checkIn = addDays(new Date(), 60);
    const checkOut = addDays(new Date(), 67);

    // Format dates to YYYY-MM-DD
    const formatDate = (date) => date.toISOString().split("T")[0];

    // Create search parameters for Duffel Stays
    const params = new URLSearchParams({
      latitude: destination.coordinates.latitude,
      longitude: destination.coordinates.longitude,
      locationName: destination.city, // Add city name for display in search form
      radius: 5,
      checkIn: formatDate(checkIn),
      checkOut: formatDate(checkOut),
      rooms: 1,
      adults: 2,
      children: 0,
      currency: "GBP",
    });

    // Navigate to hotels search with coordinates
    navigate(`/hotels/search?${params.toString()}`);
  };

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold mb-4">Popular destinations</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {destinations.map((destination) => (
          <button
            key={destination.city}
            onClick={() => handleClick(destination)}
            className="bg-gray-100 rounded-3xl overflow-hidden flex items-center hover:shadow-md transition-shadow text-left w-full h-24"
          >
            {/* Image Section - 1/3 width */}
            <div className="w-1/3 h-full">
              <img
                src={destination.image}
                alt={destination.city}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Content Section - 2/3 width */}
            <div className="w-2/3 flex items-center justify-between px-6">
              <div className="flex flex-col">
                <span className="text-3xl mb-2">{destination.flag}</span>
                <span className="text-lg font-medium">{destination.city}</span>
              </div>
              <FontAwesomeIcon
                className="bg-white p-2 w-4 h-4 rounded-full"
                icon={faChevronRight}
              />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default PopularDestinations;
